import { render, staticRenderFns } from "./ManageNewsView.vue?vue&type=template&id=67b0003a"
import script from "./ManageNewsView.vue?vue&type=script&lang=js"
export * from "./ManageNewsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports